import "./Status.css";

interface StatusProps {
  status: "inactive" | "preorder" | "new" | "available";
}

export const Status = ({ status }: StatusProps) => {
  const setText = (status: string) => {
    if (status === "new") return "Новинка";
    if (status === "preorder") return "Предзаказ";
    if (status === "inactive") return "Неактивно";
    if (status === "available") return "Доступно";
  };

  return (
    <div className="status">
      <p className="status-text">{setText(status)}</p>
    </div>
  );
};
